import { useEffect, useState } from 'react';
import { X, Sparkles } from 'lucide-react';

const KEY = 'agrinexus_beta_banner_dismissed_v1';

export default function BetaBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const dismissed = localStorage.getItem(KEY);
      if (!dismissed) setVisible(true);
    } catch {}
  }, []);

  const dismiss = () => {
    try { localStorage.setItem(KEY, '1'); } catch {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div data-testid="beta-banner" className="bg-foreground text-background text-xs">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center gap-3">
        <Sparkles size={13} className="text-chartreuse shrink-0"/>
        <div className="flex-1 leading-relaxed">
          <span className="font-semibold text-chartreuse">AgriNexus è in Beta</span>
          <span className="opacity-80"> — piattaforma <strong>100% gratuita</strong> in fase di crescita. Nessun costo per pubblicare, cercare, contattare o usare l'assistente AI.</span>
        </div>
        <button
          data-testid="beta-banner-close"
          onClick={dismiss}
          aria-label="Chiudi banner"
          className="shrink-0 opacity-60 hover:opacity-100 transition-opacity"
        >
          <X size={14}/>
        </button>
      </div>
    </div>
  );
}
